import { render, staticRenderFns } from "./PreviewFileComponent.vue?vue&type=template&id=f5da79e0&scoped=true&"
import script from "./PreviewFileComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFileComponent.vue?vue&type=style&index=0&id=f5da79e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5da79e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VDialog,VForm,VRow,VToolbar})
